import { useShare } from '../useShare'
import { Email } from './Email'

export type ShareRowProps = {
  articleTitle: string
  articleAbstract?: string
  articleId?: string
}

export const ShareRow = ({ articleTitle, articleAbstract, articleId }: ShareRowProps) => {
  const { links } = useShare({ articleTitle, articleAbstract })

  return (
    <div className="flex items-center relative max-md:items-start max-md:flex-col mt-4">
      <span className="mr-8 max-md:mb-4 text-s">Share this article</span>
      <ul className="flex items-center p-0 m-0 max-md:justify-center max-md:gap-x-4 max-md:flex-wrap">
        <Email
          articleId={articleId}
          articleTitle={articleTitle}
          articleAbstract={articleAbstract}
        />
        {links.map(({ link, Icon }) => (
          <li
            className="list-none [&:not(:last-child)]:mr-2"
            style={{ position: 'relative' }}
            key={link}
          >
            <a
              className="max-md:w-15 max-md:h-15 flex items-center justify-center w-17 h-17 rounded-[50%] bg-neutral-5 hover:bg-neutral-10"
              style={{ transition: 'background-color 0.2s ease' }}
              href={link}
              target="_blank"
              rel="noreferrer"
            >
              <Icon />
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}
